import { useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, GradeLevelOptions, GradeOptions, FilterOptions, getGradeOptions } from "../../../../../../_helpers/Helpers";
import { useSectionsUIContext } from "../SectionsUIContext";

const prepareFilter = (queryParams, values) => {
  let { gradeLevel, grade, name, capacity } = values;
  capacity = capacity === "" ? null : capacity;
  const newQueryParams = { ...queryParams };
  const filter = { gradeLevel, grade, name, capacity };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SectionsFilter() {
  // Sections UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      queryParams: sectionsUIContext.queryParams,
      setQueryParams: sectionsUIContext.setQueryParams
    };
  }, [sectionsUIContext]);

  const [gradeOptions, setGradeOptions] = useState(FilterOptions.concat(GradeOptions));
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(sectionsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, sectionsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      sectionsUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions);
  
  return (
    <Formik
      initialValues={{
        name: "",
        capacity: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  if (e.value === undefined) {
                    setGradeOptions(FilterOptions.concat(GradeOptions));
                    setFieldValue("grade", undefined);

                  } else {
                    const options = getGradeOptions(e.value);

                    if (options.length === 1) {
                      setGradeOptions(options);
                      setFieldValue("grade", options[0].value);

                    } else {
                      setGradeOptions(FilterOptions.concat(options));
                      if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", undefined);
                    }
                  }
                  setFieldValue("gradeLevel", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="capacity"
                min={1}
                placeholder="Kapasite"
                onBlur={handleBlur}
                value={values.capacity}
                onChange={(e) => {
                  setFieldValue("capacity", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kapasite</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}